import { render } from "./publications-form.vue?vue&type=template&id=7e6911e0&scoped=true"
import script from "./publications-form.vue?vue&type=script&lang=js"
export * from "./publications-form.vue?vue&type=script&lang=js"

import "./publications-form.vue?vue&type=style&index=0&id=7e6911e0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6911e0"]])

export default __exports__